import React, { useEffect, useState } from "react";
import "./CVContainer.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CV from "../CV/CV";
import { Dropdown } from "primereact/dropdown";
import CVSearchBar from "../CVSearchBar/CVSearchBar";
import { Accordion } from "primereact/accordion";
import { AccordionTab } from "primereact/accordion";
import { Toast } from "primereact/toast";
import { updatePagination } from "Redux/Actions/paginationActions";
import { useRef } from "react";
import { updateCVs } from "Redux/Actions/cvsActions";
import Loader from "Components/Loader/loader";
import TempPagination from "Components/Pagination/TempPagination";
import { useFetchGetPagination } from "Services/api";

const CVContainer = (props) => {
  const uploadToast = useRef(null);
  const cancelToast = useRef(null);

  // eslint-disable-next-line no-unused-vars
  const [triCVTheque, setTriCVTheque] = useState(null);
  const [cvsUrl, setCvsUrl] = useState(null);

  const triCVThequeData = [
    { label: "Par défaut", value: "Default" },
    { label: "Par formation", value: "Formation" },
    { label: "Par année", value: "Annee" },
  ];
  const cvRef = useRef(null);

  const cvsQuery = useFetchGetPagination(cvsUrl, props.auth.token);

  useEffect(() => {
    return () => {
      props.handleUpdateCVs({ dataFromPagination: null });
    };
  }, []);

  useEffect(() => {
    props.handleUpdateCVs({
      isCVsSearch: false,
      addedResumeId: null,
      isAddedResume: false,
    });

    let url = new URL(`${process.env.REACT_APP_BASE_URL_API}/resumes/cvteque`);
    setCvsUrl(url);
  }, []);

  // useEffect(() => {
  //   var data = props.usersData.filter(
  //     (user) =>
  //       user.resume !== null &&
  //       user.availableToWork &&
  //       user.datasVisibleForAllMembers
  //   );
  //   props.handleUpdateCVs({
  //     cvsData: data.sort((a, b) => {
  //       return b.profileCompletionRate - a.profileCompletionRate;
  //     }),
  //     cvsDataFiltered: data.sort((a, b) => {
  //       return b.profileCompletionRate - a.profileCompletionRate;
  //     }),
  //   });
  // }, [props.usersData]);

  // const handleChangeFilter = (e) => {
  //   setTriCVTheque(e.value);
  //   switch (e.value) {
  //     default:
  //       break;
  //     case "Default":
  //       return filterById();
  //     case "Formation":
  //       return filterByFormation();
  //     case "Annee":
  //       return filterByYear();
  //   }
  // };
  // const filterById = () => {
  //   props.cvs.cvsDataFiltered.sort((a, b) => {
  //     return b.profileCompletionRate - a.profileCompletionRate;
  //   });
  // };

  // const filterByFormation = () => {
  //   props.cvs.cvsDataFiltered.sort((a, b) =>
  //     a.domain.label.localeCompare(b.domain.label)
  //   );
  // };

  // const filterByYear = () => {
  //   let cvDate = [];
  //   const cvNoDate = [];
  //   //Séparation en deux liste des CV, ceux avec date de fin de diplome et ceux sans
  //   props.cvs.cvsDataFiltered.forEach((e) =>
  //     e.resume.educations[0] ? cvDate.push(e) : cvNoDate.push(e)
  //   );
  //   //Tri des CV par date de fin de diplome
  //   cvDate.sort((a, b) => {
  //     return b.resume.educations[0].endDate.localeCompare(
  //       a.resume.educations[0].endDate
  //     );
  //   });
  //   //Concaténation des deux Array
  //   cvDate = cvDate.concat(cvNoDate);
  //   props.handleUpdateCVs({
  //     cvsDataFiltered: cvDate,
  //   });
  // };

  // Affichage dynamique du nombre de CV affiché

  useEffect(() => {
    messageNumberCV();
  }, [cvsQuery?.data?.length]);

  const messageNumberCV = () => {
    switch (cvsQuery?.totalItems) {
      case null:
        return "Aucun profil ne correspond à votre recherche";
      case undefined:
        return "Aucun profil ne correspond à votre recherche";

      case 0:
        return "Aucun profil ne correspond à votre recherche";
      case 1:
        return cvsQuery?.totalItems + " profil correspond à votre recherche";
      default:
        return (
          cvsQuery?.totalItems + " profils correspondent à votre recherche"
        );
    }
  };

  return (
    <div>
      <Toast ref={uploadToast} />
      <Toast ref={cancelToast} />
      <div className="CVs__container">
        <div className="annuaire_container">
          <div className="CVs__container__title">
            <div>
              <h1 className="h1_trait_dessus">
                {props.items[props.activeIndex].label}
              </h1>
            </div>
            <div>
              <p>{messageNumberCV()}</p>
            </div>
          </div>
          <div className="annuaire_filtre">
            <div className="annuaire_filtre__label">
              <Dropdown
                value={triCVTheque}
                options={triCVThequeData}
                // onChange={(e) => handleChangeFilter(e)}
                placeholder="Trier par"
              />
            </div>
          </div>
        </div>
        <div className="offre_search_bar__filtres">
          <CVSearchBar setUrl={setCvsUrl} />
        </div>
        <Accordion expandIcon="pi pi-sliders-h" collapseIcon="pi pi-sliders-h">
          <AccordionTab header="Fitres de recherche">
            <CVSearchBar setUrl={setCvsUrl} />
          </AccordionTab>
        </Accordion>
        <div className="CVs__container__cvs" ref={cvRef}>
          {cvsQuery?.data?.length > 0 ? (
            cvsQuery.data.map((cv) => (
              <CV
                key={cv.id}
                firstname={cv.userFirstname}
                surname={cv.userSurname}
                titre={cv.profilDescription}
                cvId={cv.userId}
                educations={cv.educations}
                // roles={cv.user.userRoles}
                resumeId={cv.id}
                imageUrl={cv.imageUrl ? cv.imageUrl : null}
                certified={cv.certified}
                uploadToast={uploadToast}
                cancelToast={cancelToast}
              />
            ))
          ) : props.cvs.isCVsSearch ? (
            "Aucun CV ne correspond à votre recherche"
          ) : (
            <Loader></Loader>
          )}
        </div>
        <TempPagination
          result={cvsQuery}
          refItemParent={cvRef}
          rows={50}
        ></TempPagination>
      </div>
    </div>
  );
};

CVContainer.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  cvs: PropTypes.object,
  pagination: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
  // usersData: PropTypes.array,
  handleUpdateCVs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  cvs: state.cvs,
  pagination: state.pagination,
  // usersData: state.users.usersData,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdatePagination: (value) => {
    dispatch(updatePagination(value));
  },
  handleUpdateCVs: (value) => {
    dispatch(updateCVs(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CVContainer);
